(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["analytics-funnel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__funnelInstrumented) return;
    window.__funnelInstrumented = true;

    const root = document.querySelector('[data-analytics-funnel]');
    if (!root) return;

    function send(name, props) {
      const detail = props || {};
      try {
        const api = window[root.dataset.analyticsGlobal];
        if (api && typeof api.event === 'function') api.event(name, detail);
      } catch (error) {
        // Analytics must never be able to break a funnel it only observes.
      }
      document.dispatchEvent(new CustomEvent('funnel:track', { detail: { name, props: detail } }));
    }

    if (root.dataset.viewItem) {
      try {
        send('view_item', JSON.parse(root.dataset.viewItem));
      } catch (error) {
        // A malformed payload is not worth a broken page.
      }
    }

    document.addEventListener('cart:added', (event) => {
      const data = (event.detail && event.detail.data) || {};
      // cart/add.js answers with the line for a single add and { items: [...] }
      // for a multi-item post, which is what the finders send.
      const items = Array.isArray(data.items) ? data.items : data.id ? [data] : [];
      send('add_to_cart', {
        count: items.length,
        value: items.reduce((sum, item) => sum + (item.final_line_price || item.line_price || 0) / 100, 0),
        handles: items
          .map((item) => item.handle || '')
          .filter(Boolean)
          .join(','),
      });
    });

    document.addEventListener('click', (event) => {
      // Trusted clicks only. Measured in Phase 8: one real click on the drawer's
      // Checkout button is followed by a SECOND, untrusted click at (0,0)
      // targeting the button itself. Nothing in this theme synthesises it — it
      // comes from one of the store's app scripts — and counting it doubled
      // begin_checkout. A person choosing to check out always produces a
      // trusted event, including from the keyboard.
      if (!event.isTrusted) return;
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      const button = target.closest('[name="checkout"]');
      if (!button) return;
      send('begin_checkout', { from: button.closest('[data-cart-drawer]') ? 'drawer' : 'cart' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-terms"] && !Shopify.designMode) return;
  try {
    (function () {
    let accepted = false;
    try {
      accepted = window.sessionStorage.getItem('footbikes:terms') === '1';
    } catch (error) {
      // Storage can be blocked; the box then simply starts unticked.
    }

    function sync() {
      document.querySelectorAll('[data-checkout-gate]').forEach((gate) => {
        const box = gate.querySelector('[data-cart-terms]');
        if (!box) return;
        box.checked = accepted;
        gate.querySelectorAll('button[name="checkout"]').forEach((button) => {
          button.disabled = !accepted;
        });
      });
    }

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-terms]')) return;
      accepted = event.target.checked;
      try {
        window.sessionStorage.setItem('footbikes:terms', accepted ? '1' : '0');
      } catch (error) {
        // Not remembered across pages; still correct on this one.
      }
      sync();
    });

    document.addEventListener('cart:updated', sync);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["finder-result-card"] && !Shopify.designMode) return;
  try {
    // `window.FinderCard` — finds a candidate card, places it in a result slot,
  // and resolves its chosen option chips to a variant id.
  //
  // The one place in a finder where a variant id is derived. The chips carry the
  // values the product sells; the map carries what each combination resolves to.
  // A combination with no available variant disables the add and says so in
  // amber rather than posting an id that would fail at the cart.
  (function () {
    if (window.FinderCard) return;

    function variants(card) {
      var node = card.querySelector('[data-finder-variants]');
      if (!node) return [];
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return [];
      }
    }

    function resolve(card) {
      var list = variants(card);
      var chosen = Array.prototype.slice
        .call(card.querySelectorAll('[data-finder-option]:checked'))
        .map(function (input) {
          return input.value;
        });

      var match = null;
      if (!chosen.length) {
        match = list.filter(function (v) { return v.available; })[0] || list[0] || null;
      } else {
        match = list.filter(function (v) {
          return (
            v.options.length === chosen.length &&
            v.options.every(function (value, i) { return value === chosen[i]; })
          );
        })[0] || null;
      }

      // If that combination is sold out, keep the size the finder computed and
      // move the OTHER options to a combination that can be bought — which is
      // what a shopper would do by hand. `harness-merhi` sells XXL in one
      // colour and not the other; disabling the button there would be correct
      // and useless.
      if (!(match && match.available)) {
        var sizeInput = card.querySelector('[data-finder-size]:checked');
        var open = list.filter(function (v) { return v.available; });
        var better = null;

        if (sizeInput) {
          var position = Number(sizeInput.dataset.finderOptionPosition || 1) - 1;
          better = open.filter(function (v) {
            return v.options[position] === sizeInput.value;
          })[0];
        }
        if (!better && !chosen.length) better = open[0];

        if (better) {
          match = better;
          card.querySelectorAll('[data-finder-option]').forEach(function (input) {
            var index = Number(input.dataset.finderOptionPosition || 1) - 1;
            if (input.value === better.options[index]) input.checked = true;
          });
        }
      }

      var ok = Boolean(match && match.available);
      var field = card.querySelector('[data-finder-variant-id]');
      var note = card.querySelector('[data-finder-unavailable]');
      var add = card.querySelector('[data-finder-add]');

      if (match && field) field.value = match.id;
      if (note) note.hidden = ok;
      if (add) add.disabled = !ok;

      // Each option's legend names its checked value (`option-chips`).
      card.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('[data-finder-option]:checked');
        var label = group.querySelector('[data-option-selected]');
        if (checked && label) label.textContent = checked.value;
      });
      return match;
    }

    // The card a scorer picked, by handle, from anywhere under the finder root.
    function find(root, handle) {
      var cards = root.querySelectorAll('[data-finder-card]');
      for (var i = 0; i < cards.length; i += 1) {
        if (cards[i].dataset.finderCard === handle) return cards[i];
      }
      return null;
    }

    // Moves a card into a result slot, reveals it, and labels its role. The
    // section adds its own "why" and then calls resolve().
    function place(slot, card, role) {
      slot.textContent = '';
      slot.appendChild(card);
      card.hidden = false;

      var roleEl = card.querySelector('[data-finder-role]');
      if (roleEl) {
        roleEl.textContent = role;
        roleEl.hidden = false;
      }
      return card;
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-finder-option]');
      if (!input) return;
      var card = input.closest('[data-finder-card]');
      if (card) resolve(card);
    });

    window.FinderCard = { resolve: resolve, find: find, place: place };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["finder-shell-head"] && !Shopify.designMode) return;
  try {
    // The finder shell engine. One implementation, two finders (recipe §6). It
  // lives here, in the snippet that renders the shell's head, because this is
  // the file both finders render exactly once.
  //
  // It knows about steps, not about products: when the last visible step is
  // answered it dispatches `finder:complete` carrying every answer, and the
  // owning section scores it. That split is why the fit finder and the footbike
  // finder can disagree about everything except how a question behaves.
  //
  // Instrumentation replaces RevenueHunt's dashboard (decision D4). The store's
  // self-hosted analytics is Rybbit, which exposes `event(name, props)` on a
  // global named by `data-namespace` (default `rybbit`). The global's NAME is a
  // theme setting rather than a literal here, so swapping analytics vendors does
  // not mean editing a finder. Every event is also dispatched as a DOM event, so
  // the funnel is observable even with no analytics installed at all.
  // `window.Finder` — the two helpers both sections' result code shares. Call
  // them only inside event handlers (`finder:complete`): the order of section
  // and snippet scripts inside the compiled bundle is not something this theme
  // controls, so a section must not touch them while its own script evaluates.
  (function () {
    if (window.Finder) return;

    // The visible label of the checked answer for `name`, lower-cased, so a
    // sentence can say "riding with my dog" rather than "dog". Falls back to
    // the answer's value when the option has no label.
    function answerLabel(root, name) {
      var input = root.querySelector('[name="' + name + '"]:checked');
      if (!input) return '';
      var label = input.parentElement.querySelector('.finder-card__label, .finder-chip__label');
      return label ? label.textContent.trim().toLowerCase() : input.value;
    }

    // The concierge link: a `mailto:` carrying the answers, so a customer who
    // wants a human does not have to retype any of it.
    function mailto(email, subject, body) {
      return (
        'mailto:' +
        email +
        '?subject=' +
        encodeURIComponent(subject || '') +
        '&body=' +
        encodeURIComponent(body)
      );
    }

    window.Finder = { answerLabel: answerLabel, mailto: mailto };
  })();

  (function () {
    if (window.__finderShell) return;
    window.__finderShell = true;

    function track(root, name, props) {
      var detail = Object.assign({ finder: root.dataset.finder }, props || {});
      try {
        var api = window[root.dataset.analyticsGlobal];
        if (api && typeof api.event === 'function') api.event(name, detail);
      } catch (error) {
        // Analytics must never be able to break a funnel it only observes.
      }
      document.dispatchEvent(
        new CustomEvent('finder:track', { detail: { name: name, props: detail } })
      );
    }

    function setup(root) {
      var form = root.querySelector('[data-finder-form]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-finder-step]'));
      var counter = root.querySelector('[data-finder-counter]');
      var towline = root.querySelector('.finder__towline');
      var live = root.querySelector('[data-finder-live]');
      var result = root.querySelector('[data-finder-result]');
      var nojs = root.querySelector('[data-finder-nojs]');
      var shell = root.querySelector('[data-finder-shell]');
      if (!form || !steps.length) return;

      var index = 0;
      var started = false;
      var completed = false;

      function answers() {
        var out = {};
        new FormData(form).forEach(function (value, key) {
          out[key] = typeof value === 'string' ? value.trim() : value;
        });
        return out;
      }

      // A conditional step's controlling answers always precede it, so the
      // visible set is recomputed on every move rather than cached. `show_when`
      // is one or more comma-separated `name=value` pairs, all of which must
      // hold — a pair alone would let an answer left over from a branch the
      // customer backed out of keep a step on screen. A value may list
      // alternatives, `sport=canicross|bikejoring`, any one of which holds.
      function holds(value, expected) {
        return expected.split('|').indexOf(value) !== -1;
      }

      function visible() {
        var current = answers();
        return steps.filter(function (step) {
          var when = step.dataset.finderShowWhen;
          if (!when) return true;
          return when.split(',').every(function (condition) {
            var pair = condition.trim().split('=');
            return holds(current[pair[0]], pair[1]);
          });
        });
      }

      // Conditional steps that may still appear: every condition either holds
      // or reads an answer not given yet. Before the first branching answer the
      // length of the path is unknown, so the counter shows no total and the
      // towline counts these too, rather than reading "01 / 01" at full.
      function undecided() {
        var current = answers();
        return steps.filter(function (step) {
          var when = step.dataset.finderShowWhen;
          if (!when) return false;
          var unknown = false;
          var possible = when.split(',').every(function (condition) {
            var pair = condition.trim().split('=');
            var value = current[pair[0]];
            if (value === undefined || value === '') {
              unknown = true;
              return true;
            }
            return holds(value, pair[1]);
          });
          return possible && unknown;
        }).length;
      }

      // `quiet` updates the counter without announcing it: an answer that
      // lengthens or shortens the path is not a move to a new step.
      function progress(position, total, quiet) {
        var open = undecided();
        var pct = Math.round((position / (total + open)) * 100);
        if (counter) counter.textContent = pad(position) + (open ? '' : ' / ' + pad(total));
        if (towline) {
          towline.style.setProperty('--towline-progress', pct + '%');
          towline.setAttribute('aria-valuenow', String(pct));
        }
        if (live && !quiet) live.textContent = counter ? counter.textContent : '';
      }

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      // `initial` is the boot call, which only settles the shell into the state
      // the server already painted. It must not move focus: the first step now
      // renders visible (the CLS fix, CORRECTIONS 18d), so what used to be a
      // no-op focus() on a hidden element became a real focus steal and a 35px
      // scroll on page load. Measured, not guessed.
      function show(target, initial) {
        var list = visible();
        index = Math.min(Math.max(target, 0), list.length - 1);

        steps.forEach(function (step) {
          step.hidden = true;
        });

        var step = list[index];
        step.hidden = false;

        var back = step.querySelector('[data-finder-back]');
        if (back) back.hidden = index === 0;

        progress(index + 1, list.length);
        if (!initial) step.focus();

        track(root, 'finder_step_view', { step: step.dataset.finderStep, position: index + 1 });
      }

      // finder_start means a person began, not that a page rendered. It used to
      // fire from show() at boot, so every dog-gear PDP — where the fit finder
      // sits inline in a CLOSED panel — counted a start nobody made, and the
      // plan's finder_start -> finder_complete rate was meaningless on that
      // template. It now waits for the first real interaction with the form.
      function markStarted() {
        if (started) return;
        started = true;
        track(root, 'finder_start', {});
      }

      function validate(step) {
        var error = step.querySelector('[data-finder-error]');
        if (!step.hasAttribute('data-finder-required')) {
          if (error) error.hidden = true;
          return true;
        }

        var value = answers()[step.dataset.finderName];
        var ok = value !== undefined && value !== '';
        if (error) error.hidden = ok;
        if (!ok) {
          var first = step.querySelector('[data-finder-input]');
          if (first) first.focus();
        }
        return ok;
      }

      function complete() {
        completed = true;
        var data = answers();
        track(root, 'finder_complete', data);

        // The section fills the result synchronously in its own listener, so by
        // the time this returns there is something to reveal.
        root.dispatchEvent(
          new CustomEvent('finder:complete', { detail: { answers: data }, bubbles: true })
        );

        form.hidden = true;
        if (result) {
          result.hidden = false;
          var heading = result.querySelector('[data-finder-result-heading]');
          if (heading) heading.focus();
        }
      }

      function next() {
        var list = visible();
        var step = list[index];
        if (!validate(step)) return;

        var data = answers();
        track(root, 'finder_answer', {
          step: step.dataset.finderStep,
          value: data[step.dataset.finderName] || '',
        });

        if (index >= list.length - 1) {
          complete();
          return;
        }
        show(index + 1);
      }

      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-finder-next]')) {
          event.preventDefault();
          next();
          return;
        }
        if (event.target.closest('[data-finder-back]')) {
          event.preventDefault();
          show(index - 1);
          return;
        }
        if (event.target.closest('[data-finder-restart]')) {
          event.preventDefault();
          form.reset();
          form.hidden = false;
          if (result) result.hidden = true;
          started = false;
          completed = false;
          show(0);
        }
      });

      // Enter inside a measurement field advances, which is what a keyboard
      // user expects and what stops the page reloading.
      form.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        if (event.target.tagName === 'SUMMARY') return;
        event.preventDefault();
        next();
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        next();
      });

      form.addEventListener('input', function (event) {
        var input = event.target;
        if (input.type !== 'range') return;
        var output = input.closest('.finder-slider').querySelector('[data-finder-output]');
        if (!output) return;
        var unit = input.dataset.finderUnit;
        output.textContent = input.value + (unit ? ' ' + unit : '');
      });

      // The funnel the plan asks for: start → complete → add_to_cart. The cart
      // itself is owned by the drawer; this only records that the add came from
      // a finder result.
      root.addEventListener('submit', function (event) {
        var cartForm = event.target.closest('[data-cart-add]');
        if (!cartForm) return;
        track(root, 'finder_add_to_cart', { handle: cartForm.dataset.finderHandle || '' });
      });

      window.addEventListener('pagehide', function () {
        if (!started || completed) return;
        var list = visible();
        track(root, 'finder_abandon', { step: list[index] ? list[index].dataset.finderStep : '' });
      });

      if (nojs) nojs.hidden = true;
      if (shell) shell.hidden = false;
      form.addEventListener('change', markStarted);

      // A branching answer changes how many steps are left, so the counter is
      // recounted as soon as it is given rather than on the next move.
      form.addEventListener('change', function () {
        if (completed) return;
        var list = visible();
        progress(Math.min(index, list.length - 1) + 1, list.length, true);
      });
      form.addEventListener('click', markStarted);

      show(0, true);
    }

    document.querySelectorAll('[data-finder]').forEach(setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    // Gallery: thumbnails, ← / → paging, and "choosing a colour scrolls to its
  // photo" (via the picker's `variant:change` event on the product root).
  (function () {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

      function showMedia(mediaId) {
        if (!slides.length || !track) return;
        var target = slides.filter(function (slide) {
          return slide.dataset.mediaId === String(mediaId);
        })[0];
        if (!target) return;

        // scrollTo on the track, not scrollIntoView on the slide: the latter
        // also scrolls the PAGE, which yanks the customer away from the control
        // they just used.
        // critical.css's reduced-motion rule sets scroll-behavior: auto, but it
        // cannot reach a behavior passed to a JS scroll call. Ask the same query.
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: still ? 'auto' : 'smooth' });

        thumbs.forEach(function (thumb) {
          thumb.setAttribute(
            'aria-current',
            thumb.dataset.mediaId === target.dataset.mediaId ? 'true' : 'false'
          );
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showMedia(thumb.dataset.mediaId);
        });
      });

      // Paging arrows. Wrap-around paging over the same scroll track the
      // thumbnails drive. `navTarget` remembers where the last click was going
      // so a second click during a smooth scroll is not lost. It is cleared
      // 200ms after the track's LAST scroll event, not on a fixed clock: a
      // wrap across 18 slides scrolls for as long as the browser decides, and
      // every scroll event pushes the clear back.
      var prevButton = gallery.querySelector('[data-gallery-prev]');
      var nextButton = gallery.querySelector('[data-gallery-next]');
      var navTarget = null;
      var navTimer = 0;

      function settleSoon() {
        window.clearTimeout(navTimer);
        navTimer = window.setTimeout(function () { navTarget = null; }, 200);
      }

      function step(delta) {
        var count = slides.length;
        var width = track.clientWidth || 1;
        var base = navTarget === null ? Math.round(track.scrollLeft / width) : navTarget;
        var index = (base + delta + count) % count;
        navTarget = index;
        settleSoon();
        showMedia(slides[index].dataset.mediaId);
      }

      if (prevButton && nextButton && track && slides.length > 1) {
        prevButton.hidden = false;
        nextButton.hidden = false;
        prevButton.addEventListener('click', function () { step(-1); });
        nextButton.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', function () {
          if (navTarget !== null) settleSoon();
        }, { passive: true });
      }

      if (thumbs.length) thumbs[0].setAttribute('aria-current', 'true');

      var root = gallery.closest('[data-product]');
      if (root) {
        root.addEventListener('variant:change', function (event) {
          var variant = event.detail && event.detail.variant;
          if (variant && variant.media) showMedia(variant.media);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-height-fit-bar"] && !Shopify.designMode) return;
  try {
    // Marks the customer's own height on every fit bar on the page.
  //
  // The height is written by the Phase-5 footbike finder and lives only in this
  // browser. No profile, no marker — the bar still states the model's range,
  // which is the part that is true for everyone.
  (function () {
    var bars = document.querySelectorAll('[data-height-fit]');
    if (!bars.length) return;

    var height;
    try {
      height = Number(window.localStorage.getItem('footbikes:rider_height'));
    } catch (error) {
      return; // Storage can be blocked outright, and that is not an error state.
    }
    if (!height) return;

    bars.forEach(function (root) {
      var trackMin = Number(root.dataset.trackMin);
      var trackMax = Number(root.dataset.trackMax);
      var min = Number(root.dataset.min);
      var max = Number(root.dataset.max);
      if (!trackMax || trackMax <= trackMin) return;

      var clamped = Math.min(Math.max(height, trackMin), trackMax);
      var marker = root.querySelector('[data-height-marker]');
      var note = root.querySelector('[data-height-you]');
      if (!marker || !note) return;

      marker.style.setProperty(
        '--fit-you',
        ((clamped - trackMin) / (trackMax - trackMin)) * 100 + '%'
      );
      marker.hidden = false;

      var inRange = height >= min && height <= max;
      note.textContent =
        height + ' cm — ' + (inRange ? note.dataset.inside : note.dataset.outside);
      note.hidden = false;
      root.dataset.inRange = String(inRange);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-bar"] && !Shopify.designMode) return;
  try {
    // The bar appears only while the real button is off screen. It watches the
  // first submit button inside the form it is associated with — the add button,
  // which comes before the express wallets in that form.
  (function () {
    var bar = document.querySelector('[data-sticky-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var form = document.getElementById(bar.dataset.formId);
    var anchor = form ? form.querySelector('[type="submit"]') : null;
    if (!anchor) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }).observe(anchor);
  })();
  } catch(e) { console.error(e); }
})();

})();
